import { render, staticRenderFns } from "./Guideline.vue?vue&type=template&id=39d2ae54&scoped=true"
import script from "./Guideline.vue?vue&type=script&lang=js"
export * from "./Guideline.vue?vue&type=script&lang=js"
import style0 from "./Guideline.vue?vue&type=style&index=0&id=39d2ae54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d2ae54",
  null
  
)

export default component.exports